export default "__VITE_ASSET__BSi4kJTd__"